import { z } from 'zod';

const containsUppercase = (ch: string) => /[A-Z]/.test(ch);
const containsLowercase = (ch: string) => /[a-z]/.test(ch);

const passwordSchema = z.string().superRefine((password, ctx) => {
  let countOfUpperCase = 0,
    countOfLowerCase = 0,
    countOfDigits = 0;
  for (let i = 0; i < password.length; i++) {
    const ch = password.charAt(i);
    if (!isNaN(+ch)) countOfDigits++;
    else if (containsUppercase(ch)) countOfUpperCase++;
    else if (containsLowercase(ch)) countOfLowerCase++;
  }

  if (countOfLowerCase < 1 || countOfUpperCase < 1 || countOfDigits < 1) {
    ctx.addIssue({
      code: 'custom',
      message:
        'password must have at least one uppercase character, one lowercase character and one digit',
    });
  }
});

export function isValidPassword(password: string) {
  return passwordSchema.parse(password);
}
